import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';

const ConfirmationButtons = props => {
  const { titleConfirm, titleCancel, width, padding, handleClickConfirm, handleClickCancel, justifyContent } = props;
  return (
    <Grid style={{ width: width || '100%', display: 'flex', justifyContent: justifyContent || 'space-between', padding: padding || '20px 40px' }}>
      <Button
        variant='outlined'
        color='primary'
        style={{ padding: '6px 20px', borderRadius: { xs: '15px', md: '5px' }, fontSize: { xs: '.75rem', sm: '1rem' }, lineHeight: { xs: '.75rem', sm: '1rem' } }}
        onClick={handleClickCancel}
      >
        {titleCancel || 'Regresar'}
      </Button>
      <Button variant='contained' color='secondary' type='submit' style={{ padding: '6px 20px' }} onClick={handleClickConfirm}>
        {titleConfirm || 'Continuar'}
      </Button>
    </Grid>
  );
};

ConfirmationButtons.propTypes = {
  titleConfirm: PropTypes.any,
  titleCancel: PropTypes.any,
  width: PropTypes.any,
  padding: PropTypes.any,
  handleClickConfirm: PropTypes.any,
  handleClickCancel: PropTypes.any,
  justifyContent: PropTypes.any,
};

export default ConfirmationButtons;